import {User} from '@auth/models/user.model'
import {createReducer, on} from '@ngrx/store'
import {AUTH_STORAGE_KEYS} from '../../core/auth/auth-keys'
import * as AuthActions from '../actions/auth.actions'

/**
 * NgRx-Feature-Schlüssel - identisch zum Speicherfach des Benutzers.
 *
 * Beides muss übereinstimmen, weil der Benutzer unter genau diesem Namen im
 * `localStorage` liegt. Die Ableitung verhindert, dass die zwei Stellen
 * auseinanderlaufen.
 */
export const featureKey = AUTH_STORAGE_KEYS.user

export interface State {
  user: User | null
}

export const initialState: State = {
  user: null
}

export const reducer = createReducer(
  initialState,

  on(
    AuthActions.setAuthUser,
    (state, action): State => ({
      ...state,
      user: action.user
    })
  ),

  on(
    AuthActions.clearAuthUser,
    (state): State => ({
      ...state,
      user: null
    })
  )
)
